/**
 * Cookie Consent Banner Component
 * 
 * GDPR-compliant cookie consent for EU users.
 * Shows at bottom of page until user accepts.
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SlideUp } from './Animations';

const STORAGE_KEY = 'pleasance_cookie_consent';

function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Check if consent was already given
        const consent = localStorage.getItem(STORAGE_KEY);
        if (!consent) {
            // Small delay before showing
            const timer = setTimeout(() => setVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(STORAGE_KEY, 'accepted');
        setVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem(STORAGE_KEY, 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <SlideUp className="fixed bottom-0 left-0 right-0 z-[9998] bg-charcoal-900/95 backdrop-blur-sm border-t border-wine-500/20 px-4 py-4">
            <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
                {/* Message */}
                <p className="text-ivory-300 text-sm text-center sm:text-left">
                    We use cookies for essential functionality and anonymous analytics.
                    No tracking, no ads.{' '}
                    <Link to="/privacy" className="text-wine-400 hover:underline">
                        Learn more
                    </Link>
                </p>

                {/* Buttons */}
                <div className="flex gap-3 shrink-0">
                    <button
                        onClick={handleDecline}
                        className="px-4 py-2 text-sm text-ivory-400 hover:text-ivory-200 transition-colors"
                    >
                        Decline
                    </button>
                    <button
                        onClick={handleAccept}
                        className="px-5 py-2 text-sm bg-wine-600 hover:bg-wine-500 text-white rounded transition-colors font-medium"
                    >
                        Accept
                    </button>
                </div>
            </div>
        </SlideUp>
    );
}

export default CookieConsent;
